// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6b47645c","513":"137449bb","703":"f2202338","787":"ae711524"}[chunkId] + ".chunk.js";
};